import { GetterTree } from 'vuex';
import { AttendeeFixedCostState } from './types';
import { RootState } from '../../types';

export const getters: GetterTree<AttendeeFixedCostState, RootState> = {
  ['getAttendeeFixedCosts']: (state) => state.attendeeFixedCosts,
};
